export default "__VITE_ASSET__CL7hyVRl__"